import { render, staticRenderFns } from "./puzzleDetail.vue?vue&type=template&id=8aa00104&scoped=true"
import script from "./puzzleDetail.vue?vue&type=script&lang=js"
export * from "./puzzleDetail.vue?vue&type=script&lang=js"
import style0 from "./puzzleDetail.vue?vue&type=style&index=0&id=8aa00104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa00104",
  null
  
)

export default component.exports